import React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from './components/button/index';

const defaultItems = [];

const ToggleButtonGroup = ({
  items = defaultItems,
  selectedId = null,
  disabled = false,
  fullWidth = false,
}) => (
  <div className="ws-ui-toggle-button-group">
    {items.map((item) => (
      <ToggleButton
        {...item}
        key={item.label}
        fullWidth={fullWidth}
        selected={item.id === selectedId}
        disabled={disabled}
      />
    ))}
  </div>
);

ToggleButtonGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func,
      onKeyDown: PropTypes.func,
    })
  ),
  selectedId: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default ToggleButtonGroup;
